// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f136f5c1","337":"4076ebb6","455":"282f4a19"}[chunkId] + ".chunk.js";
};